export class SortUtils {
  /**
   * Compare function by number/string properties
   * @param a
   * @param b
   * @param property
   * @returns {number}
   */
  public static compareByProperty(a, b, property) {
    if (a[property]) {
      let propA = a[property];
      let propB = b[property];

      // If the value is not a number, we are testing a String
      if (typeof propA === 'string') {
        propA = propA.toUpperCase();
      }
      if (typeof propB === 'string') {
        propB = propB.toUpperCase();
      }

      let comparison = 0;
      if (propA > propB) {
        comparison = 1;
      } else if (propA < propB) {
        comparison = -1;
      }
      return comparison;
    }
  }

  private static compareByPropertyTwoProperties(a, b, propertyA, propertyB) {
    if (a[propertyA]) {
      let propA = a[propertyA] + a[propertyB];
      let propB = b[propertyA] + b[propertyB];

      // If the value is not a number, we are testing a String
      if (!isNaN(propA)) {
        propA = propA.toUpperCase();
      }
      if (!isNaN(propB)) {
        propB = propB.toUpperCase();
      }

      let comparison = 0;
      if (propA > propB) {
        comparison = 1;
      } else if (propA < propB) {
        comparison = -1;
      }
      return comparison;
    }
  }

  /**
   * Sorts the given result
   * @params {any} result
   * @params {string} propertyToSortBy
   */
  public static sortCollection(result, propertyToSortBy: string) {
    return !result || result.length === 0
      ? []
      : result.sort((a, b) =>
          SortUtils.compareByProperty(a, b, propertyToSortBy)
        );
  }

  public static sortCollectionByTwoProperties(
    result,
    firstPropertyToSortBy: string,
    secondPropertyToSortBy: string
  ) {
    return !result || result.length === 0
      ? []
      : result.sort((a, b) =>
          SortUtils.compareByPropertyTwoProperties(
            a,
            b,
            firstPropertyToSortBy,
            secondPropertyToSortBy
          )
        );
  }
}
